export enum StorageKey {
    AFFILIATE = 'aff',
    INVITE = 'inv',
    DEVICE_ID = 'device_id',
}
